import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import Swal from 'sweetalert2';
import {BlogCategoryService} from '../../../../shared/services/blog-category.service';

@Component({
    selector: 'app-blog-categories',
    templateUrl: './blog-categories.component.html',
    styleUrls: ['./blog-categories.component.scss']
})
export class BlogCategoriesComponent implements OnInit, OnDestroy {
    @ViewChild('formModal') formModal: TemplateRef<any>;

    categories: any[] = [];
    loading = false;
    form: FormGroup;
    editing: any | null = null;
    saving = false;

    private destroy$ = new Subject<void>();

    constructor(private fb: FormBuilder,
                private modal: NgbModal,
                private service: BlogCategoryService) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(191)]],
            description: ['', [Validators.maxLength(255)]],
            status: ['ACTIVE']
        });
        this.fetch();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    fetch(): void {
        this.loading = true;
        this.service.list({page: -1}).pipe(takeUntil(this.destroy$)).subscribe(res => {
            this.loading = false;
            this.categories = (res && res.data) ? res.data : [];
        }, () => this.loading = false);
    }

    openCreate(): void {
        this.editing = null;
        this.form.reset({name: '', description: '', status: 'ACTIVE'});
        this.modal.open(this.formModal, {centered: true});
    }

    openEdit(category: any): void {
        this.editing = category;
        this.form.patchValue({
            name: category.name,
            description: category.description,
            status: category.status
        });
        this.modal.open(this.formModal, {centered: true});
    }

    submit(modalRef: any): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        this.saving = true;
        const payload = this.form.value;
        const obs = this.editing
            ? this.service.update(this.editing.id, payload)
            : this.service.create(payload);
        obs.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.saving = false;
            modalRef.close();
            this.fetch();
        }, () => this.saving = false);
    }

    remove(category: any): void {
        Swal.fire({
            title: 'Delete this category?',
            text: category.name,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            customClass: {confirmButton: 'btn btn-danger', cancelButton: 'btn btn-outline-secondary ml-1'},
            buttonsStyling: false
        }).then(r => {
            if (r.isConfirmed) {
                this.service.remove(category.id).pipe(takeUntil(this.destroy$)).subscribe(() => this.fetch());
            }
        });
    }
}
